import { gql } from '@grandvisionhq/graphql';
import { contactLensLineItemFragment, prescriptionGlassLineItemFragment, solutionLineItemFragment, contactLensBundleLineItemFragment, nonPrescriptionBundleOrderLineItemFragment, regularLineItemFragment } from '../fragments/line-item.js';

const GET_MY_ORDER_HISTORY = gql`
  query getMyOrderHistory($offset: Int!, $limit: Int!) {
    me {
      id
      orders(offset: $offset, limit: $limit) {
        total
        failures {
          reason
        }
        results {
          orderDate
          orderNumber
          paymentStatus
          shippingInfo {
            deliveryMethodName
          }
          lineItems {
            ... on OrderLineItemRegular {
              ...RegularLineItemFragment
            }
            ... on OrderLineItemContactLens {
              ...ContactLensLineItemFragment
            }
            ... on OrderLineItemPrescriptionGlass {
              ...PrescriptionGlassLineItemFragment
            }
            ... on OrderLineItemSolution {
              ...SolutionLineItemFragment
            }
            ... on OrderLineItemBundle {
              ...ContactLensBundleLineItemFragment
            }
            ... on OrderLineItemNonPrescriptionBundle {
              ...NonPrescriptionBundleLineItemFragment
            }
          }
        }
      }
    }
  }
  ${contactLensLineItemFragment}
  ${prescriptionGlassLineItemFragment}
  ${solutionLineItemFragment}
  ${contactLensBundleLineItemFragment}
  ${nonPrescriptionBundleOrderLineItemFragment}
  ${regularLineItemFragment}
`;

export { GET_MY_ORDER_HISTORY };
//# sourceMappingURL=get-my-order-history.js.map
